import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import InvoicePageToolBar from '../../../components/admin_portal/invoice/InvoicePageToolBar';
import InvoiceTable from '../../../components/admin_portal/invoice/InvoiceTable';
import UpdateInvoice from '../../../components/admin_portal/invoice/UpdateInvoice';

class InvoiceContainer extends Component {
  handleInvoiceModal = (newVal) => {
    this.props.setInvoiceModalOpen(newVal);
  }
  render() {
    const {
      is_invoice_modal_open,
      invoice_data,
      selected_invoice
    } = this.props;
    
    return (
        <PageContainer maxWidth='xl' slots={{
            toolbar: InvoicePageToolBar,
          }} title="" sx={{
            '& .css-lc31tn > .MuiTypography-h4':{
              fontSize : '14px',
              alignSelf : {md:'center',xs:'flex-start'},
            },
            '& .css-lc31tn':{
              bgcolor : theme => theme.palette.grey[200],
              px : 1.5,
              py: 1,
              borderRadius: '10px',
              my:1.5,
              flexDirection : {md:'row',xs:'column'},
              alignItems : {md:'unset',xs :'flex-start'}
            },
            '& .css-1hwxlk6':{
              width : {md:'unset',xs:'100%'},
              flexDirection : {md:'row',xs:'column'},
              marginLeft : {md:'auto',xs:'unset!important'}
            }
          }}>
            <InvoiceTable 
              is_invoice_modal_open = {is_invoice_modal_open}
              invoice_data = {invoice_data}
            />
            <UpdateInvoice 
              is_invoice_modal_open = {is_invoice_modal_open}
              handleInvoiceModal = {this.handleInvoiceModal}
              selected_invoice = {selected_invoice}
            />
        </PageContainer>
    )
  }
}

export default InvoiceContainer;